module.exports = __webpack_public_path__ + "img/fig06.77d6a116.jpg";